import {
  ScrollView,
  type ScrollViewProps,
  type StyleProp,
  type ViewStyle,
} from 'react-native';

export type KeyboardAwareScrollViewProps = ScrollViewProps & {
  /** Style applied to the outer container (unused on web) */
  containerStyle?: StyleProp<ViewStyle>;
  /** Override the keyboard vertical offset (unused on web) */
  keyboardVerticalOffset?: number;
  /** No-op on web; stripped before props are forwarded to ScrollView */
  disableKeyboardAvoiding?: boolean;
};

/**
 * Web-specific version of KeyboardAwareScrollView.
 * On web, the browser handles keyboard avoidance natively, so we simply
 * render a ScrollView without any KeyboardAvoidingView wrapper or
 * @react-navigation/elements header-height dependency.
 */
export const KeyboardAwareScrollView = ({
  containerStyle: _containerStyle,
  keyboardVerticalOffset: _keyboardVerticalOffset,
  disableKeyboardAvoiding: _disableKeyboardAvoiding,
  children,
  keyboardShouldPersistTaps = 'handled',
  contentContainerStyle,
  ...scrollViewProps
}: KeyboardAwareScrollViewProps) => {
  return (
    <ScrollView
      keyboardShouldPersistTaps={keyboardShouldPersistTaps}
      contentContainerStyle={contentContainerStyle}
      {...scrollViewProps}
    >
      {children}
    </ScrollView>
  );
};
